import * as React from 'react';
import { css } from 'aphrodite-jss';
import logo from "../assets/images/logo-udel.png";
import {styles} from "../styles/Navbar";
import { withRouter } from 'react-router';
import axios from "axios";
import { Api } from 'src/core/api';
import { Application } from 'src/core/application';
import domtoimage from 'dom-to-image';

import JSZip from 'jszip';
import { appStore, AppStore } from 'src/mobx/AppStore';
import { toJS } from 'mobx';
import { ReportDialog } from './dialogs/ReportDialog';
import { observer, inject } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { AuthorPublications } from './AuthorPublications';
import { URLBuilder } from 'src/core/URLBuilder';
import { JsonConvert } from 'json2typescript';
import { UserInfo } from 'src/models/UserInfo';
import { Link } from 'react-router-dom';
import OutsideClickHandler from 'react-outside-click-handler';
import { SearchOptions } from 'src/models/SearchOptions';

interface IHeaderProps {
    match: any,
    location: any,
    history: any
}

class HeaderState {
    public readonly isReportDialogOpen: boolean = false;
    public readonly reportPayload: any;
    public readonly isSupportHover: boolean = false;
    public readonly isUserHover: boolean = false;
    public readonly isSearchHover: boolean = false;
    public readonly username: ""
    public readonly cb_sponsors: boolean = true;
    public readonly cb_faculty: boolean = true;
    public readonly cb_proposals_awards: boolean = true;
    public readonly cb_publications: boolean = true;
    public readonly searchTerm: string = "";
}

@inject('store')
@observer
class Header extends React.Component<IHeaderProps,HeaderState> {

    constructor(props: any){
        super(props);
        this.state = new HeaderState();
    }

    public componentDidMount() {
        axios.get(URLBuilder.user_info(),{withCredentials: true}).then((res)=>{
            if(res.status === 200){
                const jsonConvert: JsonConvert = new JsonConvert();
                const userInfo = jsonConvert.deserialize(res.data, UserInfo);
                Application.saveUserName(userInfo.username)
                this.setState({...this.state,username: userInfo.username})
            }else{
                console.log(res.statusText)
            }
        })
    }
    
    public render(){
        let supportDropDownContentStyle;
        if(this.state.isSupportHover){
            supportDropDownContentStyle = {
                display: "block",
                minWidth: "180px"
            }
        }else{
            supportDropDownContentStyle = {
                display: "none"
            }
        }

        let userDropDownContentStyle;
        if(this.state.isUserHover){
            userDropDownContentStyle = {
                display: "block",
                minWidth: "150px"
            }
        }else{
            userDropDownContentStyle = {
                display: "none"
            }
        }

        let searchDropDownContentStyle;
        if(this.state.isSearchHover){
            searchDropDownContentStyle = {
                display: "block",
                minWidth: "275px"
            }
        }else{
            searchDropDownContentStyle = {
                display: "none"
            }
        }

        const userMenuItem = (
            <React.Fragment>
                <div className={css(styles.sub_menu_item)} >
                    {this.state.username}
                </div>
                <div className={css(styles.sub_menu_item)} onClick={this.onLogoutClick}>
                    Log out
                </div> 
            </React.Fragment>
        )

        return (
        <React.Fragment >
            {this.buildReportDialog()}
            <div id="header_container" className={css(styles.header_container)}>
                <div className={css(styles.light_blue)}>
                    <img src={logo} alt="udel logo" className={css(styles.logo)} />
                </div>

                <div className={css(styles.yellow)} >

                </div>

                <div className={css(styles.dark_blue)} >
                    <div className={css(styles.title)}>
                        <Link to="/">Research office Dashboard</Link>
                    </div>

                    <div className={css(styles.menu)} >
                        
                        <div className={css(styles.menu_item)}>
                            <Link to="/">Home</Link>
                        </div>
                         <div className={css(styles.menu_item_container)} >
                              <div className={css(styles.menu_item)}>
                                <span onClick={this.onFacultyClick}>Faculty</span>
                              </div>
                         </div>
                         <div className={css(styles.menu_item_container)} >
                             <div className={css(styles.menu_item)}>
                             <span onClick={this.onCollegesClick}>Colleges & Institutes</span>
                             </div>
                         </div>
                         <div className={css(styles.menu_item_container)} >
                              <div className={css(styles.menu_item)}>
                              <span onClick={this.onSponsorClick}>Sponsors</span>

                              </div>
                         </div>
                         <div className={css(styles.menu_item_container)} >
                              <div className={css(styles.menu_item)}>
                              <span onClick={this.onCostShareClick}>Cost-Share</span>
                         </div>
                         </div>

                        {/*<OutsideClickHandler onOutsideClick={this.onSearchOutsideClick} >
                                                    <div className={css(styles.dropdown)} onClick={this.onSearchClick} >
                                                            <div className={css(styles.menu_item)} >
                                                                    Search
                                                            </div>

                                     <span>
                                      <div id="dropdown_content" className={css(styles.dropdown_content)} style={searchDropDownContentStyle} >
                                             <div className={css(styles.searchBoxContainer)} >
                                                 <input type="text" className={css(styles.searchBox)} defaultValue={this.state.searchTerm} onChange={(event: any)=>{
                                                     this.setState({...this.state, searchTerm: event.target.value})
                                                 }}
                                                     onKeyDown={this.onSearchKeyDown}
                                                 />
                                                 <div id="search_options_container" className={css(styles.searchOptionsContainer)} >
                                                     <div id="search_option_proposal" className={css(styles.searchOption)} >
                                                     <span onClick={this.onCostShareClick}>Cost-Share</span>

                                                       <input id="cb_proposals_awards" type="checkbox"  onChange={(event:any)=>{
                                                                 console.log(event.target.value)
                                                                 this.setState({...this.state, cb_proposals_awards: event.target.value})
                                                         }} />
                                                         <label htmlFor="cb_proposals_awards">Proposals & Awards</label>
                                                     </div>

                                                     <div id="search_option_faculty" className={css(styles.searchOption)}>
                                                         <input id="cb_faculty" type="checkbox"  onChange={(event:any)=>{
                                                                 this.setState({...this.state, cb_faculty: event.target.value})
                                                         }}/>
                                                         <label htmlFor="cb_faculty">Faculty</label>
                                                     </div>
                                                      <div id="search_option_sponsors" className={css(styles.searchOption)}>
                                                         <input id="cb_sponsors" type="checkbox"  onChange={(event:any)=>{
                                                           this.setState({...this.state, cb_sponsors: event.target.value})
                                                            }}/>
                                                         <label htmlFor="cb_sponsors">Sponsors</label>
                                                         </div>*
                                                     <div id="search_option_publications" className={css(styles.searchOption)} >
                                                         <input id="cb_publications" type="checkbox" defaultChecked={this.state.cb_publications} onChange={(event:any)=>{
                                                                 this.setState({...this.state, cb_publications: event.target.value})
                                                         }}/>
                                                         <label htmlFor="cb_publications">Publications</label>
                                                     </div>
                                                 </div>

                                                 <Link className={css(styles.searchAdvancedOptions)}
                                                      onClick={this.onSearchAdvancedOptionsClick}
                                                      to="/search"
                                                      >
                                                     Advanced options
                                                 </Link>
                                             </div>
                                         </div>
                                     </span>
                              </div>
                         </OutsideClickHandler> */}
                       <div className={css(styles.dropdown)} onMouseEnter={this.onSearchMouseEnter} onMouseLeave={this.onSearchMouseLeave} >
                            <div className={css(styles.menu_item)} >
                                 Search
                            </div>
                             <span>
                                <div id="dropdown_content" className={css(styles.dropdown_content)} style={searchDropDownContentStyle} >
                                    <div className={css(styles.sub_menu_item)} >
                                        <span onClick={this.onProposalSearchClick}>Proposals</span>
                                    </div>

                                     <div className={css(styles.sub_menu_item)} >
                                        <span onClick={this.onAwardSearchClick}>Awards</span>
                                     </div>
                                     {/*
                                    <div className={css(styles.sub_menu_item)} >
                                        <span onClick={this.onProposalAwardSearchClick}>Proposals & Awards</span>
                                    </div>
                                    <div className={css(styles.sub_menu_item)} >
                                        Publications
                                    </div>

                                    <div className={css(styles.sub_menu_item)}>
                                     <Link onClick={this.onSearchAdvancedOptionsClick} to="/search">Advanced options</Link>
                                    </div>
                                    */}
                                </div>
                             </span>
                       </div>



                        <div className={css(styles.dropdown)} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} >
                            <div className={css(styles.menu_item)} >
                                    Support
                            </div>
                            <span>
                                <div id="dropdown_content" className={css(styles.dropdown_content)} style={supportDropDownContentStyle} >
                                    <div className={css(styles.sub_menu_item)} >
                                        FAQ
                                    </div>
                                    <div className={css(styles.sub_menu_item)} >
                                       Glossary
                                    </div>
                                    <div className={css(styles.sub_menu_item)} >
                                        Contact
                                    </div>
                                    <div className={css(styles.sub_menu_item)} >
                                        About
                                    </div>
                                    <div className={css(styles.sub_menu_item)} onClick={this.onReportClick}>
                                        Bug Report
                                    </div>  
                                </div>
                            </span>
                        </div>

                        <div className={css(styles.dropdown)} onMouseEnter={this.onUserMouseEnter} onMouseLeave={this.onUserMouseLeave} >
                            <div className={css(styles.menu_item)} style={{minWidth: "50px", textAlign: "center", fontSize: "25px"}} >
                                <FontAwesomeIcon icon={faUserCircle} />
                            </div>
                            <span>
                                <div id="dropdown_content" className={css(styles.user_account_dropdown_content)} style={userDropDownContentStyle} >
                                    {userMenuItem}
                                </div>
                            </span>
                        </div>
                       

                    </div>

                </div>           
            </div>
        </React.Fragment>
        )
    }

    private onMouseEnter = (event: any) => {
        this.setState({...this.state,isSupportHover: true, isUserHover: false, isSearchHover: false})
    }   

    private onMouseLeave = (event: any) => {
        this.setState({...this.state,isSupportHover: false, isUserHover: false, isSearchHover: false})
    }
    private onSearchMouseEnter = (event: any) => {
            this.setState({...this.state, isSearchHover: true, isSupportHover: false, isUserHover: false})
    }

    private onSearchMouseLeave = (event: any) => {
            this.setState({...this.state,  isSearchHover: false, isSupportHover: false, isUserHover: false})
    }
    
    private onUserMouseEnter = (event: any) => {
        this.setState({...this.state,isUserHover: true,isSupportHover: false, isSearchHover: false})
    }   

    private onUserMouseLeave = (event: any) => {
        this.setState({...this.state,isUserHover: false,isSupportHover: false, isSearchHover: false})
    }  

    private onSearchClick = (event: any) => {
        this.setState({...this.state,isSearchHover: true,isSupportHover: false})
    }   

    private onSearchOutsideClick = () => {
        this.setState({...this.state,isSearchHover: false,isSupportHover: false})
    }
    
    private onSearchAdvancedOptionsClick = (event: any) => {
        event.stopPropagation();
        this.setState({...this.state,isSearchHover: false,isSupportHover: false})
    }

    private onSearchKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            this.setState({...this.state, isSearchHover: false})
            const searchOptions = new SearchOptions();
            searchOptions.keyPhrase = this.state.searchTerm;
            searchOptions.isFacultyChecked = this.state.cb_faculty;
            searchOptions.isSponsorChecked = this.state.cb_sponsors;
            searchOptions.isProposalAwardChecked = this.state.cb_proposals_awards;
            searchOptions.isPublicationChecked = this.state.cb_publications;
            this.props.history.push("/searchlist?options="+JSON.stringify(searchOptions))
        }
    }  


    private onLogoutClick = (event: any) => {
        const auth_key = Application.getAuthKey();
        const payload = {
            key: auth_key
        }
        Application.logout();
        window.location.replace("https://rdo.research.udel.edu/dashboard/accounts/logout");
    }

    private onReportClick = (event: any) => {
        const element = document.getElementById("app-content");
        const stateJSON = toJS(appStore);
        if(element !== null){
            domtoimage.toBlob(element)
            .then((blob: any) => {
                const zip = new JSZip();
                zip.file("report.png",blob);
                zip.file("state.json", JSON.stringify(stateJSON))
                zip.generateAsync({type:"blob"}).then((content: any)=>{
                    const newState = {...this.state, isReportDialogOpen: true, reportPayload: content};
                    this.setState(newState);                    
                })
            });
        }
    }

    private buildReportDialog = () => {
        return (
            <ReportDialog isOpen={this.state.isReportDialogOpen} onClose={this.onReportDialogClose} reportPayload={this.state.reportPayload} />
        );
    }

    private onReportDialogClose = () => {
        const newState = {...this.state, isReportDialogOpen: false};
        this.setState(newState);
    }
    private onFacultyClick =() => {
    if (typeof window.workbook === 'undefined'  || this.props.location.pathname ==='/'){
    this.props.history.push('/faculty')
    }
    else{
     window.workbook.activateSheetAsync("Faculty")
     }
    }
    private onSponsorClick =() => {
    if (typeof window.workbook === 'undefined' || this.props.location.pathname ==='/'){
        this.props.history.push('/sponsors')
        }
        else{
     window.workbook.activateSheetAsync("University_level_SPONSOR_DASH")
     }
    }
    private onCollegesClick =() => {
    if (typeof window.workbook === 'undefined' || this.props.location.pathname ==='/'){
        this.props.history.push('/colleges-research-institutes')
        }
        else{
      window.workbook.activateSheetAsync("Colleges_dash")
      }
    }
    private onCostShareClick =() => {
    if (typeof window.workbook === 'undefined'  || this.props.location.pathname ==='/'){
        this.props.history.push('/cost-share')
        }
        else{
      window.workbook.activateSheetAsync("Cost_share_dash")
      }
    }
    private onProposalSearchClick =() => {
       if (typeof window.workbook === 'undefined'  || this.props.location.pathname ==='/'){
       this.props.history.push('/proposal-search')
       }
       else{
          window.workbook.activateSheetAsync("Simplified_proposal_search_dash")
       }
    }
    private onAwardSearchClick =() => {
     if (typeof window.workbook === 'undefined'  || this.props.location.pathname ==='/'){
           this.props.history.push('/award-search')
         }
     else{
              window.workbook.activateSheetAsync("Simplified_award_search_dash")
          }
    }
    private  onProposalAwardSearchClick=() => {
        if (typeof window.workbook === 'undefined'  || this.props.location.pathname ==='/'){
               this.props.history.push('/proposal-award-search')
            }
        else{
                  window.workbook.activateSheetAsync("Proposal_award_search_dash")
             }
    }
}


export const HeaderWithRouter = withRouter(Header);

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.tsx